import { Box, Typography, useTheme } from '@mui/material';
import type { LensTheme } from '@diligentcorp/atlas-theme-mui-lens';
import type { Theme } from '@mui/material/styles';
import ErrorIcon from '@diligentcorp/atlas-react-icons/dist/esm/lens/Error.js';
import { atlasFontTextSm, type AtlasLensTheme } from './atlasLensStyles';
import { resolveAtlasLensColors } from './formFieldSpec';

export interface AtlasLensFormFieldErrorProps {
  message: string;
  id?: string;
}

/** Figma form field error — node I16143:101371;7919:11344 (icon + message). */
export function AtlasLensFormFieldError({ message, id }: AtlasLensFormFieldErrorProps) {
  const theme = useTheme() as Theme & LensTheme;
  const atlasTheme = theme as AtlasLensTheme;
  const { tokens } = theme;
  const { statusErrorDefault } = resolveAtlasLensColors(theme);
  const errorColor =
    (tokens.semantic.color.status.error as { content?: { value: string } } | undefined)?.content
      ?.value ?? statusErrorDefault;
  const iconSize = tokens.core.spacing['2'].value;

  return (
    <Box
      id={id}
      role="alert"
      sx={{
        display: 'flex',
        gap: tokens.core.spacing['0_5'].value,
        alignItems: 'flex-start',
        width: '100%',
      }}
    >
      <Box
        aria-hidden
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: iconSize,
          height: iconSize,
          flexShrink: 0,
        }}
      >
        <ErrorIcon
          variant="filled"
          size="lg"
          style={{
            fontSize: iconSize,
            color: errorColor,
          }}
        />
      </Box>
      <Typography
        sx={{
          ...atlasFontTextSm(atlasTheme),
          color: errorColor,
          flex: 1,
          minWidth: 0,
        }}
      >
        {message}
      </Typography>
    </Box>
  );
}
